module.exports = __webpack_public_path__ + "static/media/ab1.2eccba89.jpeg";